import './ReportsList.css';
import { formatMoney, toAmount, vat18FromCombined } from '../../utils/formatMoney';

const ReportsList = ({ data }) => {
    const credit = data[0].creditNoteDetails !== undefined;

    const calculateCreditTotal = (cart) => {
        let total = 0;

        for (let i = 0; i < cart.length; i++) {
            const item = cart[i];

            total += toAmount(item.amount) * toAmount(item.price);
        }

        return total;
    };

    const totals = {
        netTotal: 0,
        shippingTotal: 0,
        surchargeTotal: 0,
        vatTotal: 0,
        grossTotal: 0,
    };

    if (credit) {
        data.forEach((row) => {
            if (row.creditNoteDetails) {
                const itemsTotal = calculateCreditTotal(row.creditNoteDetails.items);
                const shipping = toAmount(row.creditNoteDetails.shipping);
                const surcharge = toAmount(row.creditNoteDetails.surcharge);
                const combined = itemsTotal + shipping + surcharge;
                const vat = vat18FromCombined(combined);

                totals.netTotal += combined;
                totals.shippingTotal += shipping;
                totals.surchargeTotal += surcharge;
                totals.vatTotal += vat;
                totals.grossTotal += itemsTotal;
            }
        });
    } else {
        data.forEach((row) => {
            const total = toAmount(row.order.total);
            const shipping = toAmount(row.order.shipping);
            const surcharge = toAmount(row.order.surcharge);
            const combined = total + surcharge + shipping;
            const vat = vat18FromCombined(combined);
            const net = total - shipping - surcharge - vat;

            totals.netTotal += net;
            totals.shippingTotal += shipping;
            totals.surchargeTotal += surcharge;
            totals.vatTotal += vat;
            totals.grossTotal += total;
        });
    }

    return (
        <div className="reportslist-v2-wrapper">
            <table className="reportslist-v2-table" aria-label={`${credit ? 'Credit notes' : 'Invoices'} report`}>
                <thead>
                    <tr>
                        <th>{credit ? 'Credit note' : 'Invoice'} #</th>
                        <th>Date</th>
                        <th>Net</th>
                        <th>Shipping</th>
                        <th>Surcharge</th>
                        <th>18% VAT</th>
                        <th>Gross</th>
                    </tr>
                </thead>
                <tbody>
                    {credit
                        ? data.map((row) => {
                              const itemsTotal = calculateCreditTotal(row.creditNoteDetails.items);
                              const shipping = toAmount(row.creditNoteDetails.shipping);
                              const surcharge = toAmount(row.creditNoteDetails.surcharge);
                              const combined = itemsTotal + shipping + surcharge;

                              return (
                                  <tr key={row._id} className="reportslist-v2-row reportslist-v2-row--credit">
                                      <td className="reportslist-v2-num">{row.creditNoteDetails.creditNoteNumber}</td>
                                      <td>
                                          {new Intl.DateTimeFormat('en-GB', {
                                              year: 'numeric',
                                              month: '2-digit',
                                              day: '2-digit',
                                          }).format(new Date(row.creditNoteDetails.date))}
                                      </td>
                                      <td className="reportslist-v2-money reportslist-v2-money--credit">
                                          -€{formatMoney(combined)}
                                      </td>
                                      <td className="reportslist-v2-money reportslist-v2-money--credit">
                                          -€{formatMoney(shipping)}
                                      </td>
                                      <td className="reportslist-v2-money reportslist-v2-money--credit">
                                          -€{formatMoney(surcharge)}
                                      </td>
                                      <td className="reportslist-v2-money reportslist-v2-money--credit">
                                          -€{formatMoney(vat18FromCombined(combined))}
                                      </td>
                                      <td className="reportslist-v2-money reportslist-v2-money--credit">
                                          -€{formatMoney(itemsTotal)}
                                      </td>
                                  </tr>
                              );
                          })
                        : data.map((row) => {
                              const total = toAmount(row.order.total);
                              const shipping = toAmount(row.order.shipping);
                              const surcharge = toAmount(row.order.surcharge);
                              const combined = total + surcharge + shipping;
                              const vat = vat18FromCombined(combined);
                              const net = total - shipping - surcharge - vat;

                              return (
                                  <tr key={row._id} className="reportslist-v2-row">
                                      <td className="reportslist-v2-num">{row.invoiceNumber}</td>
                                      <td>
                                          {new Intl.DateTimeFormat('en-GB', {
                                              year: 'numeric',
                                              month: '2-digit',
                                              day: '2-digit',
                                          }).format(new Date(row.date))}
                                      </td>
                                      <td className="reportslist-v2-money">€{formatMoney(net)}</td>
                                      <td className="reportslist-v2-money">€{formatMoney(shipping)}</td>
                                      <td className="reportslist-v2-money">€{formatMoney(surcharge)}</td>
                                      <td className="reportslist-v2-money">€{formatMoney(vat)}</td>
                                      <td className="reportslist-v2-money reportslist-v2-money--strong">€{formatMoney(total)}</td>
                                  </tr>
                              );
                          })}
                </tbody>
                <tfoot>
                    <tr className="reportslist-v2-foot">
                        <td colSpan={2}>Total</td>
                        <td className="reportslist-v2-money">
                            {credit && '-'}€{formatMoney(totals.netTotal)}
                        </td>
                        <td className="reportslist-v2-money">
                            {credit && '-'}€{formatMoney(totals.shippingTotal)}
                        </td>
                        <td className="reportslist-v2-money">
                            {credit && '-'}€{formatMoney(totals.surchargeTotal)}
                        </td>
                        <td className="reportslist-v2-money">
                            {credit && '-'}€{formatMoney(totals.vatTotal)}
                        </td>
                        <td className="reportslist-v2-money reportslist-v2-money--strong">
                            {credit && '-'}€{formatMoney(totals.grossTotal)}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
};

export default ReportsList;
